import Helper from './Helper';

class PrevNextTablet {
  constructor(config = {}) {
    const {
      buttonSelector,
      childTextElementSelector
    } = config;
    this.buttonSelector = buttonSelector;
    this.buttons = document.querySelectorAll(this.buttonSelector);
    this.childTextElementSelector = childTextElementSelector;
    this.buttonsArray = Array.prototype.slice.call(this.buttons);
    this.minVW = 768;
    this.maxVW = 1025;

    if(this.buttons.length > 0){
      this.bindEvents();
    }
  }

  bindEvents(){
    if (window.matchMedia("(orientation: landscape)").matches && screen.availWidth >= this.minVW && screen.availWidth < this.maxVW) {
      
      this.buttonsArray.forEach((button, i) => {
        button.addEventListener('click', (e) => {
          if ( !Helper.hasClass(button, 'focus') ) {
            e.preventDefault();
            e.stopPropagation();

            setTimeout(() => {
              button.focus();
            }, 0);

            Helper.addClass(button, 'focus');

            return false;
          } else {
            return true;
          }
        });

        button.addEventListener('blur', (e) => {
          Helper.removeClass(button, 'focus');
        });
      });
    }
  }

}

export default PrevNextTablet;
